require('../scss/styles.scss');


// WEBPACK FOOTER //
// ./C:/xampp/htdocs/ellaparkelkonsult/wp-content/themes/ellapark/js/app.js